import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { theme } from '../theme';

const ClientSelector = ({ user }) => {
  const [clients, setClients] = useState([]);
  const [selected, setSelected] = useState(localStorage.getItem('impersonatedClientId') || '');

  useEffect(() => {
    if (user?.role !== 'superadmin') return;

    const fetchClients = async () => {
      try {
        const res = await api.get('/clients');
        setClients(res.data);
      } catch (err) {
        console.error('Failed to load clients', err);
      }
    };
    fetchClients();
  }, [user]);

  if (user?.role !== 'superadmin') return null;

  const handleChange = (e) => {
    const id = e.target.value;
    setSelected(id);

    if (id) {
      localStorage.setItem('impersonatedClientId', id);
    } else {
      localStorage.removeItem('impersonatedClientId');
    }

    window.location.reload();
  };

  return (
    <select value={selected} onChange={handleChange} style={styles.select}>
      <option value="" style={styles.option}>— My Default —</option>
      {clients.map((client) => (
        <option key={client._id} value={client._id} style={styles.option}>
          {client.name}
        </option>
      ))}
    </select>
  );
};

const styles = {
  select: {
    padding: `${theme.spacing(0.75)} ${theme.spacing(1.5)}`,
    borderRadius: '4px',
    border: `1px solid ${theme.colors.accent}`,
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: theme.colors.navbarText || 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  option: {
    color: theme.colors.primary,
  },
};

export default ClientSelector;
